export function formatCurrency(
  amount: number,
  options: { currency?: string; roundDown?: boolean } = {},
): string {
  const { currency = "₽", roundDown = true } = options;
  if (isNaN(amount) || !isFinite(amount)) {
    return `- ${currency}`;
  }
  const value = roundDown ? Math.floor(amount) : amount;
  return `${value.toLocaleString("ru-RU")} ${currency}`;
}
